/** Numeric coercion for Boost `Globals.queryParams` pagination fields. */
export function boostQueryParamNumber(value, fallback = 0) {
    if (value == null || value === '') {
        return fallback;
    }
    if (Array.isArray(value)) {
        return fallback;
    }
    const parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}
